'use strict';

const consonbcashcardenrollment = 'consonbcashcardenrollment';

module.exports = {
    isOnboardingIntent: function (requestIntent) {
        if (!requestIntent) {
            return false;
        }
        return requestIntent.intent ? requestIntent.intent.toLowerCase() === consonbcashcardenrollment : false;
    }
};



/** WEBPACK FOOTER **
 ** ./public/js/utils/upgrade.js
 **/